import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import { Button } from '@abroad/components'

export const PlatformSchedulingUnavailableContent = ({
  schedulingIssues = [],
  onCancel = () => {},
  onConfirm = () => {},
}) => (
  <>
    <Modal.Header className='payment-modal-header d-flex justify-content-center'>
      <h3 className='payment-modal-title mb-0 text-uppercase'>
        Platform Scheduling Unavailable
      </h3>
    </Modal.Header>
    <Modal.Body className='payment-modal-body'>
      <div className='sa4 font-15px mb-3'>
        The following coach
        {schedulingIssues.length > 1 ? 'es are' : ' is'} not set up for platform
        scheduling. SOWs will be created with manual scheduling instead.
      </div>
      <ul className='pl-3 mb-4 sa4 font-15px'>
        {schedulingIssues.map((issue) => (
          <li key={issue.coachId} className='mb-2'>
            <span className='font-weight-bold'>{issue.coachName}</span>
            <span> — {issue.message}</span>
          </li>
        ))}
      </ul>
      <div className='sa4 font-15px mb-0'>Do you want to continue?</div>
    </Modal.Body>
    <Modal.Footer className='border-0 d-flex justify-content-end gap-3 flex-row'>
      <Button
        variant='secondary-light'
        className='px-4 text-uppercase secondary-popup-button'
        size='sm'
        onClick={onCancel}>
        Cancel
      </Button>
      <Button
        variant='saffron'
        className='px-4 text-uppercase'
        size='sm'
        onClick={onConfirm}>
        Next
      </Button>
    </Modal.Footer>
  </>
)

const PlatformSchedulingUnavailableModal = ({
  show = false,
  schedulingIssues = [],
  onCancel = () => {},
  onConfirm = () => {},
}) => {
  return (
    <Modal
      show={show}
      onHide={onCancel}
      centered
      size='lg'
      className='payment-modal'
      dialogClassName='payment-modal-dialog justify-content-center'
      backdrop='static'>
      <PlatformSchedulingUnavailableContent
        schedulingIssues={schedulingIssues}
        onCancel={onCancel}
        onConfirm={onConfirm}
      />
    </Modal>
  )
}

PlatformSchedulingUnavailableModal.propTypes = {
  show: PropTypes.bool,
  schedulingIssues: PropTypes.arrayOf(
    PropTypes.shape({
      coachId: PropTypes.string,
      coachName: PropTypes.string,
      message: PropTypes.string,
      clients: PropTypes.arrayOf(PropTypes.string),
    }),
  ),
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
}

PlatformSchedulingUnavailableContent.propTypes = {
  schedulingIssues: PropTypes.arrayOf(
    PropTypes.shape({
      coachId: PropTypes.string,
      coachName: PropTypes.string,
      message: PropTypes.string,
      clients: PropTypes.arrayOf(PropTypes.string),
    }),
  ),
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
}

export default PlatformSchedulingUnavailableModal
